import ValueListManagerView from "../presentation/views/ValueListManagerView.vue";
import ValueListDetailPlaceholderView from "../presentation/views/ValueListDetailPlaceholderView.vue";
export const valueListRoutes = [
    {
        path: "/module/value-lists",
        name: "ValueListManager",
        component: ValueListManagerView,
        meta: {
            requiresAuth: true,
            requiresCapability: "accessmanager.manage-users",
            titleKey: "valueLists.title",
        },
    },
    {
        path: "/module/value-lists/:code",
        name: "ValueListDetail",
        component: ValueListDetailPlaceholderView,
        meta: {
            requiresAuth: true,
            requiresCapability: "accessmanager.manage-users",
            titleKey: "valueLists.title",
        },
    },
];
